/**
 * The signup flow addresses the employer SSO landing (`/saml`) sends a member
 * to. They live here, beside the MVP routes, so the landing can name them
 * without importing the signup flow's screens.
 */

import { SIGNUP_FLOW_ROOT } from '@/config/signup-flow-root';

/** The signup flow's entry route. */
export const SIGNUP_ENTRY_ROUTE = SIGNUP_FLOW_ROOT;

/** The step where an SSO member picks the roster contact their code goes to. */
export const SIGNUP_SSO_CONTACT_ROUTE = `${SIGNUP_FLOW_ROOT}sso-contact/`;

/** Marks every step URL of a member the employer's SSO signed in. */
export const SIGNUP_SSO_PARAM = 'sso';
export const SIGNUP_SSO_VALUE = '1';

/** The employer a signup link names, as the legacy app read it. */
export interface SignupSponsorRefs {
  clientRef?: string;
  subClientRef?: string;
}

/**
 * `route` with `query` (already without `?`), naming the sponsor in place of
 * any the query carried. A sub-client is only kept with the client it belongs to.
 */
export function signupRoute(
  route: string,
  query: string,
  refs: SignupSponsorRefs = {},
  sso = false,
): string {
  const params = new URLSearchParams(query);
  if (refs.clientRef !== undefined) {
    params.set('client_id', refs.clientRef);
    if (refs.subClientRef !== undefined) params.set('sub_client_id', refs.subClientRef);
    else params.delete('sub_client_id');
  }
  if (sso) params.set(SIGNUP_SSO_PARAM, SIGNUP_SSO_VALUE);
  else params.delete(SIGNUP_SSO_PARAM);
  const search = params.toString();
  return search ? `${route}?${search}` : route;
}
